import { ApiEndpointParam, isErrorResponse, getErrorFromErrorResponse, ConflictType, } from '@standardnotes/responses';
import { FilterDisallowedRemotePayloadsAndMap, CreateServerSyncSavedPayload, } from '@standardnotes/models';
import { deepFreeze } from '@standardnotes/utils';
export class ServerSyncResponse {
    constructor(rawResponse) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.rawResponse = rawResponse;
        if (!isErrorResponse(rawResponse)) {
            this.successResponseData = rawResponse.data;
        }
        const conflicts = ((_a = this.successResponseData) === null || _a === void 0 ? void 0 : _a.conflicts) || [];
        const legacyConflicts = ((_b = this.successResponseData) === null || _b === void 0 ? void 0 : _b.unsaved) || [];
        this.rawConflictObjects = conflicts.concat(legacyConflicts);
        const disallowedPayloads = [];
        const savedItemsFilteringResult = FilterDisallowedRemotePayloadsAndMap(((_c = this.successResponseData) === null || _c === void 0 ? void 0 : _c.saved_items) || []);
        this.savedPayloads = savedItemsFilteringResult.filtered.map((rawItem) => {
            return CreateServerSyncSavedPayload(rawItem);
        });
        disallowedPayloads.push(...savedItemsFilteringResult.disallowed);
        const retrievedItemsFilteringResult = FilterDisallowedRemotePayloadsAndMap(((_d = this.successResponseData) === null || _d === void 0 ? void 0 : _d.retrieved_items) || []);
        this.retrievedPayloads = retrievedItemsFilteringResult.filtered;
        disallowedPayloads.push(...retrievedItemsFilteringResult.disallowed);
        this.conflicts = this.filterConflictsAndDisallowedPayloads(disallowedPayloads);
        this.vaults = ((_e = this.successResponseData) === null || _e === void 0 ? void 0 : _e.shared_vaults) || [];
        this.vaultInvites = ((_f = this.successResponseData) === null || _f === void 0 ? void 0 : _f.shared_vault_invites) || [];
        this.asymmetricMessages = ((_g = this.successResponseData) === null || _g === void 0 ? void 0 : _g.messages) || [];
        this.userEvents = ((_h = this.successResponseData) === null || _h === void 0 ? void 0 : _h.notifications) || [];
        deepFreeze(this);
    }
    filterConflictsAndDisallowedPayloads(disallowedPayloads) {
        const conflicts = this.rawConflictObjects;
        const trustedConflicts = {};
        trustedConflicts[ConflictType.InvalidServerItem] = [];
        const invalidServerConflictsArray = trustedConflicts[ConflictType.InvalidServerItem];
        for (const payload of disallowedPayloads) {
            invalidServerConflictsArray.push({
                type: ConflictType.InvalidServerItem,
                server_item: payload,
            });
        }
        for (const conflict of conflicts) {
            let serverItem;
            let unsavedItem;
            if (conflict.unsaved_item) {
                const unsavedItemFilteringResult = FilterDisallowedRemotePayloadsAndMap([conflict.unsaved_item]);
                if (unsavedItemFilteringResult.filtered.length === 1) {
                    unsavedItem = unsavedItemFilteringResult.filtered[0];
                }
                if (unsavedItemFilteringResult.disallowed.length === 1) {
                    invalidServerConflictsArray.push({
                        type: ConflictType.InvalidServerItem,
                        unsaved_item: unsavedItemFilteringResult.disallowed[0],
                    });
                }
            }
            if (conflict.server_item) {
                const serverItemFilteringResult = FilterDisallowedRemotePayloadsAndMap([conflict.server_item]);
                if (serverItemFilteringResult.filtered.length === 1) {
                    serverItem = serverItemFilteringResult.filtered[0];
                }
                if (serverItemFilteringResult.disallowed.length === 1) {
                    invalidServerConflictsArray.push({
                        type: ConflictType.InvalidServerItem,
                        server_item: serverItemFilteringResult.disallowed[0],
                    });
                }
            }
            if (!trustedConflicts[conflict.type]) {
                trustedConflicts[conflict.type] = [];
            }
            const conflictArray = trustedConflicts[conflict.type];
            if (conflictArray) {
                const entry = {
                    type: conflict.type,
                    server_item: serverItem,
                    unsaved_item: unsavedItem,
                };
                conflictArray.push(entry);
            }
        }
        return trustedConflicts;
    }
    get error() {
        if (isErrorResponse(this.rawResponse)) {
            return getErrorFromErrorResponse(this.rawResponse);
        }
        else {
            return undefined;
        }
    }
    get status() {
        return this.rawResponse.status;
    }
    get lastSyncToken() {
        var _a;
        return (_a = this.successResponseData) === null || _a === void 0 ? void 0 : _a[ApiEndpointParam.LastSyncToken];
    }
    get paginationToken() {
        var _a;
        return (_a = this.successResponseData) === null || _a === void 0 ? void 0 : _a[ApiEndpointParam.PaginationToken];
    }
    get numberOfItemsInvolved() {
        const allPayloads = [...this.retrievedPayloads, ...this.rawConflictObjects];
        return allPayloads.length;
    }
    get hasError() {
        return isErrorResponse(this.rawResponse);
    }
}
